import React, { useEffect, useState, useMemo } from "react";
import FormButtonStyle4 from "../../UIElements/FormButton"; // <-- update this path
import FormInputStyle4 from "../../UIElements/FormInput";
import Header from "../Header/header";
import callApi from "../../../../utility/apiCaller";
import { useDispatch, useSelector } from "react-redux";
import LoanSlider from "../../UIElements/RangeSlider";
import { setAmountRequired } from "../../../../store/app/aaSlice";

async function withRetry(fn, retries = 2, delay = 2000) {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (err) {
      if (attempt === retries) throw err;
      console.warn(`Retrying... attempt ${attempt + 1} failed`);
      await new Promise((r) => setTimeout(r, delay * (attempt + 1)));
      attempt++;
    }
  }
}

const formatIndianCurrency = (num) => {
  if (!num) return "";
  const cleanNum = num.replace(/[^\d]/g, ""); // remove non-digits
  if (!cleanNum) return "₹ ";

  // Format using Indian number system
  const lastThree = cleanNum.slice(-3);
  const otherNumbers = cleanNum.slice(0, -3);
  const formatted =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
    (otherNumbers ? "," : "") +
    lastThree;

  return "₹ " + formatted;
};

function getMaxAmount(offers) {
  if (!Array.isArray(offers) || offers.length === 0) return 0;

  return offers.reduce((max, offer) => {
    return offer.max_amount > max ? offer.max_amount : max;
  }, 0);
}

const demodata = { tenure: 36, interest: 18, amount: 500000 };
//   const selectedOffer={tenure: 36, interest: 18, amount: 500000}

const LoanPreApproval = ({ setCurrentStep, selectedOffer }) => {
  const [selectedLoan, setSelectedLoan] = useState(50000);
  const [showModal, setShowModal] = useState(false);
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  const dispatch = useDispatch();
  const offersData = useSelector((state) => state.app.offers);
  let leadId = aaSlice?.internalLeadId;

  const allOffers = useMemo(() => {
    return Array.isArray(offersData)
      ? offersData.flatMap((item) => item.OfferDetails || [])
      : offersData?.OfferDetails
      ? offersData.OfferDetails
      : [];
  }, [offersData]);

  console.log(allOffers);

  const MAX_AMOUNT = aaSlice?.selectedOffer?.amount || getMaxAmount(allOffers);
  const handleClickNext = () => {
    setShowModal(true); // Show the confirmation modal
  };

  const confirmAction = async () => {
    setShowModal(false);
    if (!selectedOffer && !MAX_AMOUNT) return;

    try {
      dispatch(setAmountRequired(selectedLoan));
      const payload = {
        lead: {
          amount_required: String(selectedLoan),
        },
      };

      console.log(leadId);
      await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        payload,
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );

      await withRetry(() =>
        callApi(
          `v1/lead/${leadId}/update-lead-new`,
          "post",
          {
            lead: {
              is_desired_loan_completed: true,
              steps_completed: 7,
            },
          },
          "core",
          user?.token ||
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
        )
      );

      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      console.error("Error updating lead:", error);
    }
  };

  const cancelAction = () => {
    setShowModal(false);
  };

  return (
    <div className="w-full max-w-[400px] min-h-[100dvh] overflow-hidden bg-white flex flex-col py-6">
      <Header />

      <div className="flex flex-col items-center mt-10 px-6 xs:p-2">
        <div className="bg-[#CCF8E1] relative h-[233px] w-[323px] rounded-[15px] p-4 flex flex-col items-center ">
          <img
            src="/assets/img/loanapprovalimg.png"
            alt="Loan Approved Illustration"
            className="h-[158px] w-[239px] -mt-16 mb-3 object-contain"
          />
          <p className="font-atkinson bg-[#006F59] text-[#12F280] text-[16px] mb-1 px-2">
            Your Pre-Approved Loan Amount
          </p>
          <p className="font-atkinson-bold text-[35px]  text-black -mt-1">
            {formatIndianCurrency(
              String(MAX_AMOUNT || selectedOffer?.amount || demodata?.amount)
            )}
            *
          </p>
        </div>
      </div>

      <div className="px-6 xs:px-2 mt-6">
        <p className="font-atkinson font-bold text-black text-lg mb-2">
          How Much Do You Need?
        </p>
        <LoanSlider
          min={50000}
          max={Number(MAX_AMOUNT)}
          step={5000}
          initial={Number(MAX_AMOUNT)}
          onChange={setSelectedLoan}
        />
      </div>

      <div className="mt-auto px-6 xs:px-2 mb-6">
        <FormButtonStyle4
          text="Next"
          onClick={handleClickNext}
          className="w-full font-atkinson"
        />
      </div>

      {/* Confirmation Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
            <h3 className="text-lg font-semibold mb-4">Confirm Loan Amount</h3>
            <p className="mb-4">
              Are you sure you want to request a <br /> loan of{" "}
              <span className="font-bold text-green-600">
                {formatIndianCurrency(String(selectedLoan))}
              </span>
              ?
            </p>
            <div className="flex justify-between gap-4">
              <button
                onClick={cancelAction}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
              >
                Cancel
              </button>
              <button
                onClick={confirmAction}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoanPreApproval;
